module.exports = __webpack_public_path__ + "assets/img/icon4.1.75cab185.svg";